/* 资料模块api */
import http from '@util/http';
import { administrative, core } from '../req';

// 资料目录
export async function queryMaterialDirectoryList(params) {
  return http.get(administrative.MATERIAL_DIRECTORY_LIST, params);
}

export async function queryMaterialDirectoryInfo(params) {
  return http.get(administrative.MATERIAL_DIRECTORY_INFO, params);
}

export async function querySaveMaterialDirectory(params) {
  return http.post(administrative.MATERIAL_DIRECTORY_SAVE, params);
}

export async function queryDeleteMaterialDirectory(params) {
  return http.get(administrative.MATERIAL_DIRECTORY_DELETE, params);
}

// 资料库
export async function queryMaterialDatabaseList(params) {
  return http.get(administrative.MATERIAL_DATABASE_LIST, params);
}

export async function queryMaterialDatabaseListBR(params) {
  return http.get(administrative.MATERIAL_DATABASE_LIST_BR, params);
}

export async function queryMaterialDatabaseListBM(params) {
  return http.get(administrative.MATERIAL_DATABASE_LIST_BM, params);
}

export async function queryMaterialDatabaseInfo(params) {
  return http.get(administrative.MATERIAL_DATABASE_INFO, params);
}

export async function queryMaterialDatabaseSave(params) {
  return http.post(administrative.MATERIAL_DATABASE_SAVE, params);
}

export async function queryMaterialDatabaseDelete(params) {
  return http.get(administrative.MATERIAL_DATABASE_DELETE, params);
}

export async function queryMaterialDatabaseType(params) {
  return http.get(administrative.MATERIAL_DATABASE_TYPE, params);
}

// 资料文档
export async function queryMaterialDocumentType() {
  return http.get(core.DICT_MATERIAL_DOCUMENT_TYPE);
}

export async function queryMaterialDocumentList(params) {
  return http.get(administrative.MATERIAL_DOCUMENT_LIST, params);
}

export async function queryMaterialDocumentListBR(params) {
  return http.get(administrative.MATERIAL_DOCUMENT_LIST_BR, params);
}

export async function queryMaterialDocumentListBM(params) {
  return http.get(administrative.MATERIAL_DOCUMENT_LIST_BM, params);
}

export async function queryMaterialDocumentMy(params) {
  return http.get(administrative.MATERIAL_DOCUMENT_MY, params);
}

export async function queryMaterialDocumentInfo(params) {
  return http.get(administrative.MATERIAL_DOCUMENT_INFO, params);
}

export async function querySaveMaterialDocument(params) {
  return http.post(administrative.MATERIAL_DOCUMENT_SAVE, params);
}

export async function queryDeleteMaterialDocument(params) {
  return http.get(administrative.MATERIAL_DOCUMENT_DELETE, params);
}

export async function queryMaterialDocumentLog(params) {
  return http.get(administrative.MATERIAL_DOCUMENT_LOG, params);
}

// 资料借用
export async function queryMaterialBorrowList(params) {
  return http.get(administrative.GET_MATERIAL_BORROW_LIST, params);
}

export async function queryMaterialBorrowMyList(params) {
  return http.get(administrative.GET_MATERIAL_BORROW_MY, params);
}

export async function queryMyMaterialBorrowCheckList(params) {
  return http.get(administrative.GET_MATERIAL_BORROW_CHECK, params);
}

export async function queryMaterialBorrowInfo(params) {
  return http.get(administrative.GET_MATERIAL_BORROW_INFO, params);
}

export async function querySaveMaterialBorrow(params) {
  return http.post(administrative.MATERIAL_BORROW_SAVE, params);
}

export async function queryDeleteMaterialBorrow(params) {
  return http.get(administrative.MATERIAL_BORROW_DELETE, params);
}

export async function queryNextMaterialBorrow(params) {
  return http.get(administrative.MATERIAL_BORROW_NEXT, params);
}

export async function queryReturnMaterialBorrow(params) {
  return http.post(administrative.MATERIAL_BORROW_RETURN, params);
}

export async function queryCallbackMaterialBorrow(params) {
  return http.get(administrative.MATERIAL_BORROW_CALLBACK, params);
}

export async function queryMaterialBorrowWorkflow(params) {
  return http.get(administrative.MATERIAL_BORROW_WORKFLOW, params);
}

// 资料归还
export async function queryMaterialReturnList(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_LIST, params);
}

export async function queryMaterialReturnListTodo(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_LIST_TODO, params);
}

export async function queryMaterialReturnListDone(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_LIST_DONE, params);
}

export async function queryMaterialReturnListBR(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_BR, params);
}

export async function queryMaterialReturnListBRTodo(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_BR_TODO, params);
}

export async function queryMaterialReturnListBRDone(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_BR_DONE, params);
}

export async function queryMaterialReturnListBM(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_BM, params);
}

export async function queryMaterialReturnListBMTodo(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_BM_TODO, params);
}

export async function queryMaterialReturnListBMDone(params) {
  return http.get(administrative.GET_MATERIAL_RETURN_BM_DONE, params);
}

export async function querySaveMaterialReturn(params) {
  return http.post(administrative.MATERIAL_RETURN_SAVE, params);
}

export async function queryRenewalMyList(params = {}) {
  return http.get(administrative.GET_MATERIAL_RENEWAL_MY, params);
}

export async function queryRenewalList(params = {}) {
  return http.get(administrative.GET_MATERIAL_RENEWAL_LIST, params);
}

export async function queryRenewalInfo(params = {}) {
  return http.get(administrative.GET_MATERIAL_RENEWAL_INFO, params);
}

export async function querySaveRenewal(params = {}) {
  return http.post(administrative.MATERIAL_RENEWAL_SAVE, params);
}

export async function queryNextRenewal(params = {}) {
  return http.get(administrative.MATERIAL_RENEWAL_NEXT, params);
}

export async function queryNextRenewalUpload(params) {
  return http.post(administrative.MATERIAL_RENEWAL_NEXT_UPLOAD, params);
}

export async function queryNextRenewalScan(params) {
  return http.post(administrative.MATERIAL_RENEWAL_NEXT_SCAN, params);
}

export async function queryNextRenewalArchive(params) {
  return http.post(administrative.MATERIAL_RENEWAL_NEXT_ARCHIVE, params);
}

export async function queryReturnRenewal(params) {
  return http.post(administrative.MATERIAL_RENEWAL_RETURN, params);
}

export async function queryCallbackRenewal(params) {
  return http.get(administrative.MATERIAL_RENEWAL_CALLBACK, params);
}

export async function queryRenewalWorkflow(params) {
  return http.get(administrative.MATERIAL_RENEWAL_WORKFLOW, params);
}



// WEBPACK FOOTER //
// ./src/api/administrative/material.js